import React from 'react'

const DataWrapper = (props) => {
    const { heading, children } = props
    return (
        <div className='w-full pb-5 space-y-4'>
            <h2 className="text-[#2d4667] uppercase font-bold text-2xl font-['Myriad_Pro']
           " >
                {heading}
            </h2>
            <div className="w-full space-y-5 font-['Myriad_Pro']">
                {children}
            </div>
        </div>
    )
}

export default DataWrapper
